'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"page-header":"alloy-page-module_page-header__E8hpw","page-header--primary":"alloy-page-module_page-header--primary__2qH0c","page-header--small":"alloy-page-module_page-header--small__NQAco","page-header--secondary":"alloy-page-module_page-header--secondary__ZdcA4"};

exports.default = styles;
//# sourceMappingURL=alloy-page.module.scss.js.map
